import { render, staticRenderFns } from "./TheoryExamProtocolPreview.vue?vue&type=template&id=24fa4612&"
import script from "./TheoryExamProtocolPreview.vue?vue&type=script&lang=ts&"
export * from "./TheoryExamProtocolPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports